module.exports = __webpack_public_path__ + "img/1.94ff00b1.jpeg";